var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-bg"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('loader',{attrs:{"loading-bar":false}})],1):_vm._e(),(_vm.expired)?_c('div',{staticClass:"div"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v(" Your session has expired. "),_c('br'),_vm._v(" We will redirect you to the login page. ")])
}]

export { render, staticRenderFns }